import React from 'react';
import { Tag, Tooltip, Icon } from 'antd';
import { get } from 'lodash';
import MetricRow from './MetricRow';
import s from '../AnnualReviewReport.module.scss';

const USAGE_HEALTH_OPTIONS = [
  'Active & used well',
  'Underutilized',
  'Low / Inactive',
];

const USAGE_HEALTH_COLORS = {
  [USAGE_HEALTH_OPTIONS[0]]: 'green',
  [USAGE_HEALTH_OPTIONS[1]]: 'orange',
  [USAGE_HEALTH_OPTIONS[2]]: 'red',
};

const ModuleSection = ({
  title,
  enabled,
  moduleData = {},
  statConfigs = [],
  isPrograms,
  reviewYear,
  usageHealth,
  showEnabledTag,
}) => {
  const noPrograms = isPrograms && get(moduleData, 'noPrograms', false);
  const programNames = get(moduleData, 'programNames', []);

  const stats = statConfigs.map(
    ({ key, label, healthKey, tooltip, format }) => ({
      key,
      label,
      value: get(moduleData, key),
      healthColor: healthKey ? get(moduleData, healthKey) : null,
      tooltip,
      format,
    })
  );

  const showUsageHealth =
    usageHealth != null && USAGE_HEALTH_OPTIONS.includes(usageHealth);

  return (
    <div className={s.moduleSection}>
      <div className={s.moduleHeader}>
        <span className={s.moduleTitle}>{title}</span>
        {showEnabledTag && (
          <Tag color={enabled ? 'green' : 'default'}>
            {enabled ? 'Enabled' : 'Disabled'}
          </Tag>
        )}
      </div>
      {noPrograms ? (
        <p className={s.noProgramsMessage}>
          No programs started in {reviewYear}
        </p>
      ) : (
        <>
          {isPrograms && programNames.length > 0 && (
            <div className={s.programNames}>
              <strong>
                Program names:
                <Tooltip
                  title={`List of all formal programs that had activity in ${reviewYear}.`}
                >
                  <Icon
                    type="info-circle"
                    style={{
                      color: '#8c8c8c',
                      cursor: 'help',
                      marginLeft: 4,
                    }}
                    aria-label="More info about Program names"
                  />
                </Tooltip>
              </strong>
              <div className={s.programNamesList}>
                {programNames.join(', ')}
              </div>
            </div>
          )}
          <div className={s.moduleStats}>
            {stats.map(
              ({ key, label, value, healthColor, tooltip, format }) => (
                <MetricRow
                  key={key}
                  label={label}
                  value={value}
                  healthColor={healthColor}
                  tooltip={tooltip}
                  format={format}
                />
              )
            )}
          </div>
        </>
      )}
      {showUsageHealth && (
        <div className={s.usageHealthRow}>
          <span className={s.usageHealthLabel}>Usage Health:</span>
          <Tag
            color={USAGE_HEALTH_COLORS[usageHealth] || 'red'}
            aria-label={`Usage health: ${usageHealth}`}
          >
            {usageHealth}
          </Tag>
        </div>
      )}
    </div>
  );
};

export default ModuleSection;
